import React from "react";
import Skeleton from '@material-ui/lab/Skeleton';
import { Grid } from '@material-ui/core';
import useWindowHeight from '../../../shared_elements/hooks/useWindowHeight';
const ProjectViewsSkeleton = ({}) => {
    const windowHeight = useWindowHeight();
    return(
        <div>
            <Skeleton style={{marginBottom:'10px'}} variant="rect" height={40} />
            <Grid container alignItems='center' spacing={1}>
                <Grid item xs={12} md={12}>
                    <Skeleton variant="rect" width={'100%'} height={windowHeight - 220} />
                </Grid>
            </Grid>
        </div>
    )
}
export default ProjectViewsSkeleton;